/**
 * MADE-065: HighlightsBar
 * Metric summary row at top of ManufacturingHub.
 */

import React from 'react';
import { Box, Paper, Typography, Stack } from '@mui/material';
import type { WorkOrder } from '../../types/madebb.types';

interface HighlightsBarProps {
  workOrders: WorkOrder[];
  activeOrderCount: number;
  stockAlertCount: number;
}

interface MetricCardProps {
  label: string;
  value: number;
  color?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ label, value, color = '#1976d2' }) => (
  <Paper
    elevation={1}
    sx={{
      flex: 1,
      minWidth: 140,
      p: 2,
      borderTop: `4px solid ${color}`,
      textAlign: 'center',
    }}
  >
    <Typography variant="h4" fontWeight={700} color={color}>
      {value}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Paper>
);

export const HighlightsBar: React.FC<HighlightsBarProps> = ({
  workOrders,
  activeOrderCount,
  stockAlertCount,
}) => {
  const blockedCount = workOrders.filter(wo => wo.kanbanStatus === 'blocked').length;

  const qcCount = workOrders.filter(wo => wo.kanbanStatus === 'quality_check').length;

  const today = new Date().toDateString();
  const dueTodayCount = workOrders.filter(
    wo => wo.dueDate && new Date(wo.dueDate).toDateString() === today
  ).length;

  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        <MetricCard label="Active Orders" value={activeOrderCount} color="#1976d2" />
        <MetricCard label="Blocked" value={blockedCount} color="#d32f2f" />
        <MetricCard label="In QC" value={qcCount} color="#0288d1" />
        <MetricCard label="Due Today" value={dueTodayCount} color="#ed6c02" />
        {stockAlertCount > 0 && (
          <MetricCard label="Stock Alerts" value={stockAlertCount} color="#f57c00" />
        )}
      </Stack>
    </Box>
  );
};
